/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardCompetitionResponse } from './LeaderboardCompetitionResponse';
import {
    LeaderboardCompetitionResponseFromJSON,
    LeaderboardCompetitionResponseFromJSONTyped,
    LeaderboardCompetitionResponseToJSON,
    LeaderboardCompetitionResponseToJSONTyped,
} from './LeaderboardCompetitionResponse';

/**
 * Wrapper envelope for the leaderboard detail endpoint. The handler attaches dynamic fields (totalValueFuel, winnerPoolFuel, isUsdMode, lastCompletedPeriod, etc.) to the inner `leaderboard` object beyond what `LeaderboardCompetitionResponse` declares — the inner $ref captures the stable shape, additional dynamic fields are tolerated by clients.
 * @export
 * @interface GetLeaderboardByIdOrSlugResponse
 */
export interface GetLeaderboardByIdOrSlugResponse {
    /**
     * 
     * @type {LeaderboardCompetitionResponse}
     * @memberof GetLeaderboardByIdOrSlugResponse
     */
    leaderboard: LeaderboardCompetitionResponse;
}

/**
 * Check if a given object implements the GetLeaderboardByIdOrSlugResponse interface.
 */
export function instanceOfGetLeaderboardByIdOrSlugResponse(value: object): value is GetLeaderboardByIdOrSlugResponse {
    if (!('leaderboard' in value) || value['leaderboard'] === undefined) return false;
    return true;
}

export function GetLeaderboardByIdOrSlugResponseFromJSON(json: any): GetLeaderboardByIdOrSlugResponse {
    return GetLeaderboardByIdOrSlugResponseFromJSONTyped(json, false);
}

export function GetLeaderboardByIdOrSlugResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeaderboardByIdOrSlugResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboard': LeaderboardCompetitionResponseFromJSON(json['leaderboard']),
    };
}

export function GetLeaderboardByIdOrSlugResponseToJSON(json: any): GetLeaderboardByIdOrSlugResponse {
    return GetLeaderboardByIdOrSlugResponseToJSONTyped(json, false);
}

export function GetLeaderboardByIdOrSlugResponseToJSONTyped(value?: GetLeaderboardByIdOrSlugResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboard': LeaderboardCompetitionResponseToJSON(value['leaderboard']),
    };
}

